import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCenterTabModule } from './resource-center-tab/resource-center-tab.module';
import { ResourceCenterModule } from './resource-center-side-bar/resource-center.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ResourceCenterModule, ResourceCenterTabModule],
  exports: [ResourceCenterModule, ResourceCenterTabModule],
})
export class ResourceCenterContainerModule {}
